module.exports = require('./CardSkeleton');
